module.exports = __webpack_public_path__ + "img/photo-59.473488a5.png";